/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MediaSourceQuality } from './MediaSourceQuality';
import {
    MediaSourceQualityFromJSON,
    MediaSourceQualityFromJSONTyped,
    MediaSourceQualityToJSON,
    MediaSourceQualityToJSONTyped,
} from './MediaSourceQuality';

/**
 * 
 * @export
 * @interface CampaignNumberDataSource
 */
export interface CampaignNumberDataSource {
    /**
     * 
     * @type {string}
     * @memberof CampaignNumberDataSource
     */
    campaignId?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignNumberDataSource
     */
    campaignRemoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignNumberDataSource
     */
    campaignName?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignNumberDataSource
     */
    integrationId?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignNumberDataSource
     */
    integrationName?: string;
    /**
     * 
     * @type {{ [key: string]: number | null; }}
     * @memberof CampaignNumberDataSource
     */
    dataNet?: { [key: string]: number | null; };
    /**
     * 
     * @type {{ [key: string]: number | null; }}
     * @memberof CampaignNumberDataSource
     */
    dataGross?: { [key: string]: number | null; };
    /**
     * 
     * @type {{ [key: string]: MediaSourceQuality; }}
     * @memberof CampaignNumberDataSource
     */
    mediaSourceQuality?: { [key: string]: MediaSourceQuality; };
    /**
     * 
     * @type {CampaignNumberDataSourceFinanceScopeEnum}
     * @memberof CampaignNumberDataSource
     */
    financeScope?: CampaignNumberDataSourceFinanceScopeEnum;
}


/**
 * @export
 */
export const CampaignNumberDataSourceFinanceScopeEnum = {
    CanonicalSelected: 'canonical_selected'
} as const;
export type CampaignNumberDataSourceFinanceScopeEnum = typeof CampaignNumberDataSourceFinanceScopeEnum[keyof typeof CampaignNumberDataSourceFinanceScopeEnum];


/**
 * Check if a given object implements the CampaignNumberDataSource interface.
 */
export function instanceOfCampaignNumberDataSource(value: object): value is CampaignNumberDataSource {
    return true;
}

export function CampaignNumberDataSourceFromJSON(json: any): CampaignNumberDataSource {
    return CampaignNumberDataSourceFromJSONTyped(json, false);
}

export function CampaignNumberDataSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CampaignNumberDataSource {
    if (json == null) {
        return json;
    }
    return {
        
        'campaignId': json['campaignId'] == null ? undefined : json['campaignId'],
        'campaignRemoteId': json['campaignRemoteId'] == null ? undefined : json['campaignRemoteId'],
        'campaignName': json['campaignName'] == null ? undefined : json['campaignName'],
        'integrationId': json['integrationId'] == null ? undefined : json['integrationId'],
        'integrationName': json['integrationName'] == null ? undefined : json['integrationName'],
        'dataNet': json['dataNet'] == null ? undefined : json['dataNet'],
        'dataGross': json['dataGross'] == null ? undefined : json['dataGross'],
        'mediaSourceQuality': json['mediaSourceQuality'] == null ? undefined : (mapValues(json['mediaSourceQuality'], MediaSourceQualityFromJSON)),
        'financeScope': json['financeScope'] == null ? undefined : json['financeScope'],
    };
}

export function CampaignNumberDataSourceToJSON(json: any): CampaignNumberDataSource {
    return CampaignNumberDataSourceToJSONTyped(json, false);
}

export function CampaignNumberDataSourceToJSONTyped(value?: CampaignNumberDataSource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'campaignId': value['campaignId'],
        'campaignRemoteId': value['campaignRemoteId'],
        'campaignName': value['campaignName'],
        'integrationId': value['integrationId'],
        'integrationName': value['integrationName'],
        'dataNet': value['dataNet'],
        'dataGross': value['dataGross'],
        'mediaSourceQuality': value['mediaSourceQuality'] == null ? undefined : (mapValues(value['mediaSourceQuality'], MediaSourceQualityToJSON)),
        'financeScope': value['financeScope'],
    };
}

